import {
  OfflineExecutionContext,
  OfflineTaskPayloadMap,
  OfflineTaskResultMap,
  OfflineTaskType,
} from '@zonofi/zono-money-store';
import { OfflineTaskMeta } from './types';

type TaskHandlerArgs<T extends OfflineTaskType> =
  OfflineTaskPayloadMap[T] extends void
    ? [meta: OfflineTaskMeta, ctx: OfflineExecutionContext]
    : [
        payload: OfflineTaskPayloadMap[T],
        meta: OfflineTaskMeta,
        ctx: OfflineExecutionContext,
      ];

export type TaskHandler<T extends OfflineTaskType> = (
  ...args: TaskHandlerArgs<T>
) => Promise<OfflineTaskResultMap[T]>;

const registry = new Map<OfflineTaskType, TaskHandler<any>>();

export function registerTask<T extends OfflineTaskType>(
  type: OfflineTaskType,
  handler: TaskHandler<T>
) {
  registry.set(type, handler);
}

export function getTaskHandler<T extends OfflineTaskType>(
  type: T
): TaskHandler<T> {
  const handler = registry.get(type);
  if (!handler) {
    throw new Error(`No task registered for type: ${type}`);
  }
  return handler;
}
